import React from 'react';
export default function Image(props) {
    return (React.createElement("img", Object.assign({}, props)));
}
